class Beneficio {
    constructor(
        {
            id = null,        
            nome_beneficio = null,
            ind_ativo = null,
            valor_parcela = null,
            numero_parcelas = null,
            termo_beneficio = null,
            sigla_beneficio = null,
            usuario_inclusao = null, 
            data_registro_inclusao = null, 
            usuario_alteracao = null, 
            data_registro_alteracao = null        
        } = {}
    ) {
        this.id = id; 
        this.nome_beneficio = nome_beneficio,       
        this.ind_ativo = ind_ativo,
        this.valor_parcela = valor_parcela,
        this.numero_parcelas = numero_parcelas,
        this.termo_beneficio = termo_beneficio,
        this.sigla_beneficio = sigla_beneficio,
        this.usuario_inclusao = usuario_inclusao, 
        this.data_registro_inclusao = data_registro_inclusao, 
        this.usuario_alteracao = usuario_alteracao, 
        this.data_registro_alteracao = data_registro_alteracao          
    }
}

export default Beneficio;